//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectedAnswers from '../_query_components/selected_answers'
import { INHERIT_QR } from '@/views/personal_package/_const/query'
export default {
    components: {
        SelectedAnswers
    },
    props: {
        answered_questions: Array,
        result: String,
        desc: String,
    },
    data () {
        return {
            qr: INHERIT_QR
        }
    }
}
